<template>
  <b-modal
    ref="sync-generic-devices"
    id="sync-generic-devices"
    @show="onShow"
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    size="lg"
    centered
  >
    <div style="height: 525px; max-width: 100%; overflow-y: auto">
      <b-card no-body class="m-2">
        <b-card-body>
          <b-row>
            <b-col cols="12" md="12" class="mb-md-0 mb-2 text-capitalize">
              <label>{{ $tc("proxy_rtsp_server.title", 2) }}</label>
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="proxyServersFilter"
                :options="proxyRtspServersOptions"
                class="w-100"
                :reduce="(val) => val.value"
                multiple
								@input="onFiltersChange"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-card class="m-2" no-body>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
								@input="onFiltersChange"
              />
              <label class="text-capitalize">{{ $t("table.entries") }} </label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                  v-model="searchQuery"
									@input="onTypeSearch"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refGenericDevicesItemsSync"
          class="position-relative"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="$t('no_record_found')"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #head(name)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #head(ethMacAddress)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #head(id)="">
            <b-form-checkbox
              id="select-all"
              :value="true"
              :unchecked-value="false"
              v-model="selectAll"
              box
							@input="onSelectAll"
            >
            </b-form-checkbox>
          </template>

          <template #cell(id)="data">
            <b-form-checkbox
              :disabled="data.item.exist"
              :id="`camera-${data.item.id}`"
              :value="data.item.id"
              unchecked-value="0"
              v-model="camerasId"
            >
            </b-form-checkbox>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalList"
                :per-page="perPage"
                prev-class="prev-item"
                next-class="next-item"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <template #modal-footer>
			<b-button
				size="sm"
				variant="secondary"
				class="text-capitalize"
				@click="$bvModal.hide('sync-generic-devices'); clear()"
			>
				{{ $t("actions.close") }}
			</b-button>
      <b-button
        variant="info"
        size="sm"
        class="text-capitalize"
        :disabled="camerasId.length === 0"
        @click="syncGenericDevices"
      >
        {{ $t("generic_devices.sync_devices") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BTable, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, computed } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import Pagination from "@/components/Pagination.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import { debounce } from "lodash";
import axios from "@/libs/axios";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    vSelect,
    Pagination,
    ToastificationLoadingContent,
  },
  props: {
    proxyRtspServersOptions: {
      type: Array,
      default: null,
    },
    proxyRtspServersFilter: {
      type: Array,
      default: null,
    },
  },

  setup(props, { emit }) {
    const isBusy = ref(false);
    const perPage = ref(10);
    const totalList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref(null);
    const cameras = ref([]);
    const camerasId = ref([]);
    const selectAll = ref(false);
    const toast = useToast();
    const proxyServersFilter = ref([]);
    const openModal = ref(false);
    const refGenericDevicesItemsSync = ref(null);

		const fetchList = (ctx, callback) => {
			store.dispatch('generic_devices/getAll', {
				q: searchQuery.value,
				max: perPage.value,
				'page[n]': currentPage.value,
				proxy_rtsp_server: proxyServersFilter.value ?? null,
				with_proxy_rtsp_server: true,
				with_path: true,
			})
				.then(response => {
					callback(response.data)
					cameras.value = response.data
					totalList.value = response.meta.total
				})
				.catch((e) => {
					console.log(e)
					contentToast('Error getting data', 'danger')
				})
		}

		const onFiltersChange = ()=> {
			refGenericDevicesItemsSync.value.refresh()
		}

		const onTypeSearch = debounce(function () {
      refGenericDevicesItemsSync.value.refresh();
    }, 800);

		const contentToast = (message, type) => {
      toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "CheckIcon",
          variant: type,
        },
      });
    }

    const dataMeta = computed(() => {
      const localItemsCount = refGenericDevicesItemsSync.value
        ? refGenericDevicesItemsSync.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalList.value,
      };
    });

    const clear = () => {
      selectAll.value = false;
      cameras.value = [];
      camerasId.value = [];
    };

    const syncGenericDevices = async () => {
			try {
				const payload = {
					isSelectAll: selectAll.value,
					proxy_rtsp_server: proxyServersFilter.value ?? null,
					camerasId: selectAll.value ? null : camerasId.value
				};
        // sync paths in proxy rtsp server
				emit("loadingSyncDevices", true);
        let { data } = await axios.post(`/v1/generic-device/sync-paths`, payload);
        let { message, success } = data
        emit("loadingSyncDevices", false);
        if (!success) {
          contentToast('Unsuccessful synchronization of devices', 'danger')
          return;
        }

        contentToast(message, 'success')
      } catch(e) {
				const message = e.response.data.message ?? "Error on sync devices";
        emit("loadingSyncDevices", false);
        contentToast(message, 'danger')
      }
    };

    const onShow = () => {
      openModal.value = false;
      proxyServersFilter.value = props.proxyRtspServersFilter;
    };

    const onSelectAll = () => {
      camerasId.value = selectAll.value ? cameras.value.map(camera => camera.id) : []
    };

    return {
      isBusy,
      perPage,
      totalList,
      currentPage,
      perPageOptions,
      refGenericDevicesItemsSync,
      tableColumns: [
        { label: "", key: "id", sortable: false },
        { label: "camera.name", key: "name", sortable: false },
        { label: "path", key: "path", sortable: false },
      ],
      selectAll,
      camerasId,
      dataMeta,
      searchQuery,
      fetchList,
      syncGenericDevices,
      onShow,
      openModal,
      proxyServersFilter,
			onFiltersChange,
			refGenericDevicesItemsSync,
			onTypeSearch,
			clear,
			onSelectAll
    };
  },
};
</script>